import { getJson } from 'utils/http/getJson';

export async function apiFetchUserByEmail(email: string) {
  return getJson<{ userExists: boolean } | null>(
    `/data/users/by-email?email=${encodeURIComponent(email)}`,
  ).then((result) => result?.userExists);
}
